import { useEffect, useRef } from 'react';
import { postDownloadExcel } from '@/lib/downloadExcel';

export type ExportCell = string | number | null;

/** Money/qty to 2 decimals so the sheet doesn't carry float noise. */
export const xl = (v: unknown): ExportCell =>
  typeof v === 'number' ? Math.round(v * 100) / 100 : v == null ? null : String(v);

/**
 * Accounts reports are filtered, grouped and searched in the browser, so the
 * export sends exactly those rows (all of them, not just the current page)
 * for the server to turn into an .xlsx.
 */
export function exportReport(fileName: string, sheetName: string, headers: string[], rows: ExportCell[][]) {
  return postDownloadExcel('/accounts/export.xlsx', { fileName, sheetName, headers, rows }, `GRHAMOY_${fileName}.xlsx`);
}

/** Runs `fn` each time `signal` changes after mount — lets a page's Export button drive its table. */
export function useOnSignal(signal: number | undefined, fn: () => void) {
  const last = useRef(signal);
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    if (signal === undefined || signal === last.current) return;
    last.current = signal;
    fnRef.current();
  }, [signal]);
}
